// src/utils/dateUtils.js

/**
 * Parses a date string (YYYY-MM-DD) into a Date object set to local midnight.
 * @param {string} dateStr - The date string in YYYY-MM-DD format.
 * @returns {Date} - The parsed Date object.
 */
export const parseLocalDate = (dateStr) => {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day); // Months are 0-indexed in JS Date
};

// src/utils/dateUtils.js

export const formatDate = (timestamp) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp.seconds * 1000);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const calculateRenewDate = (timestamp) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp.seconds * 1000);
  date.setFullYear(date.getFullYear() + 1);
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
